module.exports = __webpack_public_path__ + "static/media/MG.3e8e872f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/MG.svg
// module id = 311
// module chunks = 0